<mat-card appearance="outlined">
    <mat-card-content>
        <mat-card-header>
            <mat-card-title>{{ 'Dashboard.ChatControl' | translate }}</mat-card-title>
            <div class="right-button" slHideIfDashboardEditMode>
                <button mat-icon-button (click)="exportChat()" [disabled]="isExportingCsv">
                    <mat-icon>list_alt</mat-icon>
                </button>
                <button mat-icon-button (click)="deleteChat()">
                    <mat-icon>delete</mat-icon>
                </button>
            </div>
        </mat-card-header>
        @if (currentConversations().length > 0) {
            <div class="chat-control">
                <div class="conversation-summaries">
                    @for (conversation of currentConversations(); track conversation.message) {
                        <!-- eslint-disable @angular-eslint/template/eqeqeq -->
                        <div
                            class="conversation-summary"
                            [class.selected]="conversation.shareholderId == selectedShareholderId"
                            [class.unread]="!conversation.readTime && conversation.isFromShareholder"
                            [class.replied]="!conversation.isFromShareholder"
                            (click)="selectConversation(conversation.shareholderId)">
                            <div class="requester-name">
                                {{ conversation.shareholderDisplayName }}
                            </div>
                            <div class="time">
                                {{ conversation.sendTime | date: 'shortTime' : '' : currentLocaleCode }}
                            </div>
                            <div class="replied-indicator">
                                <span class="material-icons">reply</span>
                            </div>
                            <div class="message-summary">
                                {{ conversation.message }}
                            </div>
                            <div class="unread-indicator"></div>
                        </div>
                        <!-- eslint-enable @angular-eslint/template/eqeqeq -->
                    }
                </div>
                <div class="conversation">
                    @if (!!selectedShareholderId()) {
                        <sl-chat-conversation [messages]="currentMessages()" [shareholderId]="selectedShareholderId()" />
                    } @else {
                        <div class="empty-conversation">
                            <span>{{ 'Chat.SelectConversation' | translate }}</span>
                        </div>
                    }
                </div>
            </div>
        } @else {
            <div class="empty-conversation">
                <span>{{ 'Chat.NoConversations' | translate }}</span>
            </div>
        }
    </mat-card-content>
</mat-card>
